import React, { useEffect, useState } from "react";
import { Swipeable } from "react-swipeable";
// import { useMediaQuery } from "beautiful-react-hooks";
import Link from "../../utils/Link";

export default function Slide({
  orientation,
  width,
  images,
  children,
  title,
  more = "See more",
  link,
  active = false,
  onClick,
  onSwipedLeft,
  onSwipedRight,
}) {
  // const mediaMobile = useMediaQuery(
  //   "(min-width: 320px) and (max-width: 768px)"
  // );

  // const mediaTablet = useMediaQuery(
  //   "(min-width: 769px) and (max-width: 1024px)"
  // );

  // const display =
  //   mediaMobile || mediaTablet
  //     ? active
  //       ? { opacity: 1, display: "block" }
  //       : { opacity: 0, display: "none" }
  //     : {};

  return (
    <div
      className={`${
        active
          ? "presentation__item kwicks-selected kwicks-expanded kwicks-completed"
          : "presentation__item kwicks-collapsed"
      }`}
      style={{ width, ...orientation }}
      onClick={() => onClick()}
    >
      <Swipeable
        onSwipedLeft={() => onSwipedLeft()}
        onSwipedRight={() => onSwipedRight()}
      >
        <figure
          // className="presentation__image presentation__image--overlay object-fit-container"
          className="presentation__image object-fit-container"
        >
          <picture>
            <source srcSet={images.high} media="(min-width: 600px)" />
            <img srcSet={images.low} alt="Slider" />
          </picture>
          <figcaption className="presentation__text">{children}</figcaption>
        </figure>
        {link && (
          <Link target="_self" to={link} className="presentation__link-wrap">
            {more}
          </Link>
        )}
        <div className="presentation__item--title">{title}</div>
      </Swipeable>
    </div>
  );
}
